import angular from 'angular';

import {StartViewComponent} from './start-view.component';

import photoUploaderModule from '../../components/photo-uploader';
import projectBrowserModule from '../../components/project-browser';

export const startViewModule = angular.module('slViz.startViewModule', [
    photoUploaderModule,
    projectBrowserModule
])
    .component('startView', StartViewComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/views/start-view/index.js